import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Category } from 'projects/oct-report-lib/src/public-api';

@Injectable()
export class SwayCategoryDataService extends DefaultDataService<any> {
    headers: { [key: string]: string } = {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Access-Control-Allow-Origin': '*',
    };

    constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
        super('Category', http, httpUrlGenerator);
    }

    setHeaders(headers: { [key: string]: string }) {
        this.headers = {
            ...this.headers,
            ...headers,
        };
    }

    override getAll(): Observable<Category[]> {
        return this.http
            .get<any[]>(`/api/report/categories`, {
                headers: this.headers,
            })
            .pipe(
                map((res: any) => res),
                catchError((err) => {
                    console.log('[error] SwayCategoryDataService:', JSON.stringify(err));
                    return of(err);
                }),
            );
    }
}
